import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { MobileBlocker } from '../../../components/mobile-blocker';
import { ProductTemplatePage } from '../../../components/product-template-editor/product-template-page';
import { trackError } from '../../../error/tracking';
import { captureException } from '../../../logger/capture-exception';
import { Feature, isFeatureAvailable } from '../../../shared/feature';

export const Route = createFileRoute('/app/product-template/new')({
  // eslint-disable-next-line no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  useEffect(
    function () {
      if (!isFeatureAvailable(Feature.PRODUCT)) {
        navigate({ to: '/app/blogs' }).catch(function (err) {
          captureException(
            err,
            {
              file: 'src/routes/app/product-template/new.tsx',
              method: 'navigate',
              infoMessage: 'unable to navigate to /app/blogs',
            },
            trackError
          );
        });
      }
    },
    [navigate]
  );

  return (
    <>
      <MobileBlocker />
      <ProductTemplatePage
        onClose={function () {
          navigate({ to: '/app/products/templates' }).catch(function (err) {
            captureException(
              err,
              {
                file: 'src/routes/app/product-template/new.tsx',
                method: 'onClose',
                infoMessage: 'unable to navigate to /app/products/templates',
              },
              trackError
            );
          });
        }}
        templateIsUsedByProducts={false}
      />
    </>
  );
}
